var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C0.725 9 0.489667 8.90217 0.294 8.7065C0.0983334 8.51083 0.000333333 8.27533 0 8V1C0 0.725 0.098 0.489667 0.294 0.294C0.49 0.0983334 0.725333 0.000333333 1 0H6.5875C6.72083 0 6.848 0.025 6.969 0.075C7.09 0.125 7.19617 0.195833 7.2875 0.2875L8.7125 1.7125C8.80417 1.80417 8.875 1.9105 8.925 2.0315C8.975 2.1525 9 2.2795 9 2.4125V8C9 8.275 8.90217 8.5105 8.7065 8.7065C8.51083 8.9025 8.27533 9.00033 8 9H1ZM8 2.425L6.575 1H1V8H8V2.425ZM4.5 7.5C4.91667 7.5 5.27083 7.35417 5.5625 7.0625C5.85417 6.77083 6 6.41667 6 6C6 5.58333 5.85417 5.22917 5.5625 4.9375C5.27083 4.64583 4.91667 4.5 4.5 4.5C4.08333 4.5 3.72917 4.64583 3.4375 4.9375C3.14583 5.22917 3 5.58333 3 6C3 6.41667 3.14583 6.77083 3.4375 7.0625C3.72917 7.35417 4.08333 7.5 4.5 7.5ZM2 3.5H5.5C5.64167 3.5 5.7605 3.452 5.8565 3.356C5.9525 3.26 6.00033 3.14133 6 3V2C6 1.85833 5.952 1.73967 5.856 1.644C5.76 1.54833 5.64133 1.50033 5.5 1.5H2C1.85833 1.5 1.73967 1.548 1.644 1.644C1.54833 1.74 1.50033 1.85867 1.5 2V3C1.5 3.14167 1.548 3.2605 1.644 3.3565C1.74 3.4525 1.85867 3.50033 2 3.5ZM1 2.425V8V1V2.425Z",
    fill: "#573B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.2a93a4a76437374d8cf7c3d95e48c546.svg";
export { ForwardRef as ReactComponent };